import PriceWithCurrency from './PriceWithCurrency'

export default PriceWithCurrency
